import { useEffect, useState } from 'react';
import { lastTripitRun } from '../lib/api';
import type { TripitRun } from '../lib/types';
import { WatercolorBloom } from '../components/WatercolorBloom';

export default function Settings() {
  const [run, setRun] = useState<TripitRun | null>(null);
  useEffect(() => { lastTripitRun().then(setRun); }, []);

  return (
    <div className="col" style={{ gap: 24 }}>
      <section className="card brackets" style={{ position: 'relative', overflow: 'hidden', padding: 28 }}>
        <WatercolorBloom variant="uv" size={300} opacity={0.3} style={{ position: 'absolute', top: -100, right: -80 }} />
        <span className="label-bright">// SYSTEM STATUS</span>
        <h1 className="h2" style={{ marginTop: 8 }}>Atlas — Settings</h1>
        <p className="body muted" style={{ marginTop: 8, maxWidth: 560 }}>Operational controls. Sync, members, build info.</p>
      </section>

      <section className="card">
        <span className="label">// TRIPIT SYNC</span>
        {run ? (
          <div className="col" style={{ gap: 6, marginTop: 8 }}>
            <div className="row" style={{ gap: 10 }}>
              <span className="h3">Last run</span>
              <span className={`pill pill-${run.status === 'ok' ? 'in_progress' : run.status === 'partial' ? 'planning' : 'idea'}`}>{run.status.toUpperCase()}</span>
            </div>
            <div className="body">Ran at: {new Date(run.ran_at).toLocaleString()}</div>
            <div className="body">Source: <span className="label-bright">{run.source}</span></div>
            <div className="body">Trips seen: <b>{run.trips_seen}</b> · inserted: <b>{run.trips_inserted}</b> · updated: <b>{run.trips_updated}</b></div>
            {run.error_message && <div className="body" style={{ color: '#FF2BD6' }}>Error: {run.error_message}</div>}
            <div className="label muted" style={{ marginTop: 8 }}>Next scheduled run: daily at 09:00 local (launchd)</div>
          </div>
        ) : (
          <div className="body muted" style={{ marginTop: 8 }}>TripIt sync has not run yet. The daily 09:00 launchd job will populate this once configured.</div>
        )}
      </section>

      <section className="card">
        <span className="label">// MEMBERS</span>
        <h3 className="h3" style={{ marginTop: 8 }}>Single-owner mode</h3>
        <p className="body muted" style={{ marginTop: 4, maxWidth: 560 }}>
          v1 is just you. The schema is role-aware — a lower-privilege viewer login can be added with a single insert into <code>atlas_members</code>.
        </p>
      </section>

      <section className="card">
        <span className="label">// BUILD</span>
        <p className="body muted" style={{ marginTop: 8 }}>Atlas v0.1 · Cyberpunk Watercolor · {new Date().toLocaleDateString()}</p>
      </section>
    </div>
  );
}
